// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import { useLocation } from "react-router-dom";
import {
  Button,
  Modal,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Alert,
  AlertTitle
} from "@mui/material";
import { PropsWithChildren, useEffect, useRef, useState } from "react";
import { Header, HeaderProps } from "../molecules";
import { Sidebar } from "../organisms";
import { HeaderNotification } from "../atoms";
import { initialUserInfoState, useUserInfo } from "../../store/User.state";
import dayjs from "dayjs";
import { useSetSnackBar } from "../../store/Snackbar.state";
import { useNavigate } from "react-router-dom";
import { StorageKeys } from "../../common/storageKeys";
import { useGetUserMenuList, useLogout } from "../../hooks";
import { axiosInstance } from "../../config/axios";
import WatchLaterTwoToneIcon from "@mui/icons-material/WatchLaterTwoTone";
import { darken } from "@mui/material/styles";
import clockImage from "../../assets/images/clock.png";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export type AdminTemplateProps = PropsWithChildren<{
  headerProps: HeaderProps;
  showHeaderTitle?: boolean;
}>;

const WarningBanner = () => {
  return (
    <div className="max-w mx-auto p-6">
      <Alert
        severity="warning"
        icon={<ErrorOutlineIcon fontSize="inherit" />}
        className="rounded-lg border border-red-300 bg-red-50 text-red-700"
      >
        <AlertTitle className="font-semibold">Bilgilendirme</AlertTitle>
        Ödemeniz, şüpheli işlem (fraud) nedeniyle işyeriniz tarafından geçici olarak bloke edilmiştir.
      </Alert>
    </div>
  );
};

export const AdminTemplate = ({
  headerProps,
  children,
  showHeaderTitle = true
}: AdminTemplateProps) => {
  let title = "";
  const [hideSaveButton, setHideSaveButton] = useState(false);
  const pathNameSplitted = useLocation().pathname.split("/");
  const location = useLocation();
  const pathName = pathNameSplitted[pathNameSplitted.length - 1];
  const { mutate: logout } = useLogout();
  const { data: userMenu } = useGetUserMenuList();
  // const isDesktops = useMediaQuery('(min-width:600px)');
  userMenu?.data.forEach((menuItem) => {
    if (menuItem.childs?.length) {
      menuItem.childs.forEach((childMenu) => {
        if (childMenu.id === pathName) {
          title = childMenu.title;
        }
      });
    }
  });

  const logoutReq = async () => {
    try {
      await axiosInstance.post("/Auth/Logout");
      setUserInfo(initialUserInfoState);
      localStorage.setItem(StorageKeys.bearerToken, "");
      navigate("/");
    } catch (error) {
      setSnackbar({
        severity: "error",
        description: "işlem Başarısız",
        isOpen: true,
      });
    }

  }


  useEffect(() => {
    userMenu?.data.forEach((menuItem) => {
      if (menuItem.childs?.length) {
        menuItem.childs.forEach((childMenu) => {
          if (childMenu.id === pathName) {
            setHideSaveButton(!childMenu.create);
          }
        });
      }
    });
  }, [pathName, userMenu?.data]);

  const navigate = useNavigate();
  const theme = useTheme();
  const [userInfo, setUserInfo] = useUserInfo();
  const setSnackbar = useSetSnackBar();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [openModal, setOpenModal] = useState(false);
  const [modalTimeLeft, setModalTimeLeft] = useState(16); // 16 saniye

  const logoutTimer = useRef(null);
  const modalTimeout = useRef(null);
  const timeInterval = useRef(null);

  const handleLogout = (fromTimeout = false) => {

    logout({}, {
      onSuccess: () => {
        setOpenModal(false);
        setUserInfo(initialUserInfoState);
        localStorage.removeItem(StorageKeys.bearerToken);
        localStorage.removeItem(StorageKeys.expireDate);
        setSnackbar({
          severity: fromTimeout ? "error" : "success",
          description: fromTimeout
            ? "İşlem yapmadığınız için sistemden çıkış yapıldı."
            : "Giriş sayfasına yönlendirildiniz.",
          isOpen: true,
        });
        navigate("/");
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      }
    });
  };


  function startLogoutTimer() {
    if (logoutTimer.current) {
      clearTimeout(logoutTimer.current);
    }

    logoutTimer.current = setTimeout(() => {
      setOpenModal(true);
      setModalTimeLeft(16);

      timeInterval.current = setInterval(() => {
        setModalTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      modalTimeout.current = setTimeout(() => {
        handleLogout(true);
        clearInterval(timeInterval.current);
      }, 16000);
    }, window.location.host == "localhost:3000" ? 3000000 : 1200000); // 20 dk olarak revize edildi, localhost için 50 dk bırakıldı
  }

  function continueSession() {
    setOpenModal(false);
    clearTimeout(modalTimeout.current);
    clearInterval(timeInterval.current);
    startLogoutTimer(); // Zamanlayıcıyı tekrar başlat
  }
  function resetTimerOnUserActivity() {
    if (!openModal) {
      startLogoutTimer();
    }
  }

  useEffect(() => {
    startLogoutTimer();



    window.addEventListener("click", resetTimerOnUserActivity);
    window.addEventListener("keypress", resetTimerOnUserActivity);
    window.addEventListener("scroll", resetTimerOnUserActivity);

    // const requestInterceptor = axiosInstance.interceptors.request.use(
    //   (config) => {
    //     resetTimerOnUserActivity();
    //     return config;
    //   },
    //   (error) => {
    //     return Promise.reject(error);
    //   }
    // );

    return () => {
      clearTimeout(logoutTimer.current);
      clearTimeout(modalTimeout.current);
      clearInterval(timeInterval.current);
      window.removeEventListener("click", resetTimerOnUserActivity);
      window.removeEventListener("keypress", resetTimerOnUserActivity);
      window.removeEventListener("scroll", resetTimerOnUserActivity);
      // axiosInstance.interceptors.request.eject(requestInterceptor);
    };
  }, [setUserInfo, navigate, setSnackbar, setOpenModal, setModalTimeLeft, location.pathname]);

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const tokenInLocalStorage = localStorage.getItem(StorageKeys.bearerToken);

      // 401 hatası ve token localStorage'ta varsa
      if (
        error.response &&
        error.response.status === 401 &&
        tokenInLocalStorage
      ) {

        logout({}, {
          onSuccess: () => {
            setSnackbar({
              severity: "error",
              description: "Oturumdan çıkış yapıldı.",
              isOpen: true,
            });
            setUserInfo(initialUserInfoState);
            navigate("/");

            localStorage.removeItem(StorageKeys.bearerToken);
            localStorage.removeItem(StorageKeys.expireDate);
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          }
        });
        // 401 hatası ve token localStorage'ta yoksa
      } else if (
        error.response &&
        error.response.status === 401 &&
        !tokenInLocalStorage
      ) {

        logout({}, {
          onSuccess: () => {
            setSnackbar({
              severity: "error",
              description: "Lütfen Giriş Yapınız.",
              isOpen: true,
            });
            setUserInfo(initialUserInfoState);
            navigate("/");
            localStorage.removeItem(StorageKeys.bearerToken);
            localStorage.removeItem(StorageKeys.expireDate);
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          }
        });
      }

      return Promise.reject(error);
    }
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const expiredDate = dayjs(
        localStorage.getItem(StorageKeys.expireDate)
      ).subtract(3, "hour");
      const now = dayjs(new Date());
      if (expiredDate.diff(now) < 0) {
        logoutReq()
        setSnackbar({
          severity: "error",
          description: "İşlem süreniz dolmuştur. Lütfen tekrar giriş yapınız.",
          isOpen: true,
        });

      }
    }, 1000);
    return () => clearInterval(interval);
  }, [navigate, setSnackbar, setUserInfo, userInfo.expireDate, logoutReq]);


  useEffect(() => {
    const sendHeartbeat = async () => {
      try {
        const response = await axiosInstance.get("/Auth/HealthCheck");
      } catch (error) {
        console.error("API error:", error);
      }
    };

    // Hemen bir istek gönder ve ardından interval'ı başlat
    if (location.pathname !== '/') {
      sendHeartbeat();
      const intervalId = setInterval(sendHeartbeat, 10000);

      // Cleanup function
      return () => clearInterval(intervalId);
    }
  }, [location.pathname]);

  const isAddPage = pathName === "add";
  const hideButtonCondition =
    headerProps.hideAddButton ||
    pathName === "dashboard" ||
    pathName === "payment-reporting" ||
    pathName === "merchant-payment" ||
    pathName === "bank-payment" ||
    isAddPage ||
    hideSaveButton;

  return (
    <Stack direction="row" sx={{
      display: 'flex',
      minHeight: '100vh',
    }}>
      {isDesktop && <Sidebar />}
      <Stack minHeight={isDesktop ? undefined : "100vh"} flex={1} sx={{
        flexGrow: 1,
        ml: isDesktop ? '260px' : 0, // Add margin to prevent content from going under sidebar
        overflowY: 'auto',
        height: '100vh',
      }}>
        {/* <Header {...headerProps} headerTitle={pathName === 'dashboard' ? "Ana Ekran" : title} hideAddButton={pathName === "dashboard" || pathName === "payment-reporting" || pathName === "merchant-payment" ||  pathName === "bank-payment" || hideSaveButton}/>  */}
        <Header
          {...headerProps}
          headerTitle={showHeaderTitle ?
            (pathName === "dashboard" ? "Ana Ekran" : title) ||
            headerProps.headerTitle
            : ''}
          hideAddButton={hideButtonCondition}
          alertElement={
            userInfo.isPayoutBlocked && (<HeaderNotification
              severity="error"
              message={`Ödemeniz "${userInfo.payoutBlockReason}" nedeniyle geçici olarak durdurulmuştur.`}
            />)
          }
        />
        {/* <Header
          {...headerProps}
          headerTitle={
            headerProps.headerTitle ||
            (pathName === "dashboard" ? "Ana Ekran" : title)
          }
          hideAddButton={hideButtonCondition}
        /> */}

        <Stack
          borderRadius={3}
          m={isDesktop ? 2 : 1}
          flex={1}
          sx={{ backgroundColor: "white" }}
        >
          {children}
        </Stack>
      </Stack>
      <Modal
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        open={openModal}
      >
        <Stack
          borderRadius={2}
          p={isDesktop ? 8 : 2}
          sx={{
            backgroundColor: "white",
            width: isDesktop ? 500 : "90%",
            height: 500,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            "::before": {
              content: '""',
              position: "absolute",
              top: "-50px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "88px",
              height: "88px",
              backgroundImage: `url(${clockImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              borderRadius: "50%",
              backgroundColor: "white",
              border: "4px solid #0C9FDC",
            },
          }}
        >
          <Typography mb={2} color="InfoText" variant="h3">
            Hala burada mısınız?
          </Typography>
          <Typography
            color="#489dd6"
            fontWeight="bold"
            fontSize={16}
            textAlign="center"
          >
            İşlem süresi dolmuştur, Devam butonuna basarak işlemlerinize devam
            edebilirsiniz.
          </Typography>
          <Typography color="text.default" variant="h5" textAlign="center">
            Devam etmediğiniz takdirde, "{modalTimeLeft}"saniye içinde panelden
            atılacaksınız.
          </Typography>
          <Stack direction="row" gap={2} mt={3}>
            <Button
              onClick={continueSession}
              sx={{
                backgroundColor: "#489dd6",
                "&:hover": {
                  backgroundColor: darken("#489dd6", 0.1),
                },
                color: "white",
                fontWeight: "bold",
                fontSize: "1.1rem",
              }}
            >
              Devam
            </Button>
            <Button
              onClick={() => handleLogout(false)}
              sx={{
                backgroundColor: "#ff0000",
                "&:hover": {
                  backgroundColor: darken("#ff0000", 0.1),
                },
                color: "white",
                fontWeight: "bold",
                fontSize: "1.1rem",
              }}
            >
              Giriş Sayfası
            </Button>
          </Stack>
        </Stack>
      </Modal>
    </Stack>
  );
};
